<template>
  <v-layout row wrap>
    <v-flex xs12>
      <SummaryTitle
        :isCollapsible="isCollapsible"
        :isCollapsed="isCollapsed"
        icon="location_on"
        @clickedToggle="toggleIsCollapsed">
        Property
        <template v-if="displayAction" v-slot:action>
          <EditButton @click="clickEditLocation" />
        </template>
      </SummaryTitle>
    </v-flex>

    <template v-if="!contentIsCollapsed">
      <v-flex class="summarylocation--address" xs12>
        <FormattedAddress
          :street="location.address1"
          :street-2="location.address2"
          :city="location.city"
          :state="location.state"
          :postal-code="location.postalCode" />
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

import EditButton from '@/components/common/EditButton.vue';
import FormattedAddress from '@/components/common/FormattedAddress.vue';
import SummaryTitle from '@/components/common/SummaryTitle.vue';
import CollapsibleSection from '@/mixins/CollapsibleSection';
import StepUtilities from '@/router/utilities/step-utilities';

export default {
  components: {
    EditButton,
    FormattedAddress,
    SummaryTitle,
  },
  mixins: [CollapsibleSection],
  computed: {
    ...mapState('Appointment', {
      location: state => state.locationComponentData,
    }),
  },
  methods: {
    clickEditLocation() {
      StepUtilities.goToPropertyStep(this.$router);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/mixins/breakpoints';
@import '../styles/vars/typography';
</style>
